// Event-delegated handlers for the cart drawer footer (discount panel + share link).
// Lives outside cart-subtotal.liquid so it survives the cart's appendChild-based refreshes.
(function(){
	function $(id){ return document.getElementById(id); }

	function applyDiscountUiFromMemory(){
		var input = $('amana-discount-input');
		var badge = $('amana-discount-badge');
		var badgeCode = $('amana-discount-badge-code');
		if ( !input || !badge || !badgeCode ) return;
		var form = input.parentElement;
		var panel = badge.closest('.amana-discount-panel');
		var code = window.__amanaDiscountCode || '';
		if ( code ) {
			badgeCode.textContent = code.toUpperCase();
			badge.style.display = 'flex';
			if ( form ) form.style.display = 'none';
			if ( panel ) panel.classList.add('open');
		} else {
			badge.style.display = 'none';
			if ( form ) form.style.display = '';
			input.value = '';
		}
	}

	function onDiscountSave(){
		var input = $('amana-discount-input');
		if ( !input ) return;
		var code = (input.value || '').trim();
		if ( !code ) return;
		window.__amanaDiscountCode = code;
		applyDiscountUiFromMemory();
	}

	function onDiscountRemove(){
		window.__amanaDiscountCode = '';
		applyDiscountUiFromMemory();
	}

	function fallbackCopy(text){
		var ta = document.createElement('textarea');
		ta.value = text;
		ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px';
		document.body.appendChild(ta);
		ta.focus(); ta.select();
		try { document.execCommand('copy'); } catch(e) {}
		document.body.removeChild(ta);
	}

	function onShareCart(){
		var items = document.querySelectorAll('#AjaxCartForm [data-js-cart-item]');
		if ( !items.length ) return;
		var parts = [];
		items.forEach(function(item){
			var vid = item.dataset.variant;
			var qty = item.dataset.qty || '1';
			if ( vid ) parts.push(vid + ':' + qty);
		});
		var url = window.location.origin + '/pages/mon-panier-amana?items=' + parts.join(',');
		var textEl = $('amana-share-text');
		var btn = $('amana-share-cart');
		if ( !textEl || !btn ) return;

		function onCopySuccess(){
			textEl.textContent = 'Copié';
			btn.classList.add('copied');
			// Garde anti-accumulation : un re-clic réinitialise le timer au lieu d'en empiler un nouveau.
			if ( btn._amanaResetTimer ) clearTimeout(btn._amanaResetTimer);
			btn._amanaResetTimer = setTimeout(function(){
				textEl.textContent = 'Copier le lien du panier';
				btn.classList.remove('copied');
			}, 2500);
		}

		var done = false;
		var finish = function(){ if (done) return; done = true; onCopySuccess(); };

		if ( navigator.clipboard && navigator.clipboard.writeText ) {
			navigator.clipboard.writeText(url).then(finish).catch(function(){
				fallbackCopy(url); finish();
			});
			setTimeout(function(){ if (!done) { fallbackCopy(url); finish(); } }, 600);
		} else {
			fallbackCopy(url); finish();
		}
	}

	function onShareTempClick(btn){
		var items = document.querySelectorAll('#AjaxCartForm [data-js-cart-item]');
		if ( !items.length ) return;
		var parts = [];
		items.forEach(function(item){
			var vid = item.dataset.variant;
			var qty = item.dataset.qty || '1';
			if ( vid ) parts.push(vid + ':' + qty);
		});
		var url = window.location.origin + '/pages/mon-panier-amana?items=' + parts.join(',');
		if ( navigator.share ) {
			navigator.share({
				title: 'Regarde ce que j’ai trouvé sur AMANA !',
				text: 'Des sacs de luxe vintage certifiés authentiques',
				url: url
			}).catch(function(){});
		}
	}

	function openPromoModal(){
		var m = document.getElementById('amana-discount-modal');
		if ( !m ) return;
		m.classList.add('open');
		m.setAttribute('aria-hidden', 'false');
		var input = $('amana-discount-input');
		if ( input && !window.__amanaDiscountCode ) setTimeout(function(){ try { input.focus(); } catch(e){} }, 50);
	}
	function closePromoModal(){
		var m = document.getElementById('amana-discount-modal');
		if ( !m ) return;
		m.classList.remove('open');
		m.setAttribute('aria-hidden', 'true');
	}

	// Affiche le bouton "Partager" natif uniquement si l'API Web Share existe (mobile surtout).
	function revealNativeShare(){
		if ( !navigator.share ) return;
		document.querySelectorAll('#amana-share-native').forEach(function(b){ b.style.display = 'inline-flex'; });
	}

	document.addEventListener('click', function(e){
		if ( !e.target.closest ) return;
		var save = e.target.closest('#amana-discount-save');
		if ( save ) { e.preventDefault(); onDiscountSave(); return; }
		var remove = e.target.closest('#amana-discount-remove');
		if ( remove ) { e.preventDefault(); onDiscountRemove(); return; }
		var share = e.target.closest('#amana-share-cart');
		if ( share ) { e.preventDefault(); onShareCart(); return; }
		var shareNative = e.target.closest('#amana-share-native');
		if ( shareNative ) { e.preventDefault(); onShareTempClick(shareNative); return; }
		var promoOpen = e.target.closest('[data-amana-promo-open]');
		if ( promoOpen ) { e.preventDefault(); openPromoModal(); return; }
		var promoClose = e.target.closest('[data-amana-promo-close]');
		if ( promoClose ) { e.preventDefault(); closePromoModal(); return; }
		// Clic sur l'overlay (hors de la box) ferme la modale
		var modal = e.target.closest('[data-amana-promo-modal]');
		if ( modal && !e.target.closest('.amana-discount-modal__box') ) { e.preventDefault(); closePromoModal(); return; }
	});

	document.addEventListener('keydown', function(e){
		if ( e.key === 'Escape' || e.keyCode === 27 ) closePromoModal();
	});

	document.addEventListener('cart-updated', function(){ applyDiscountUiFromMemory(); revealNativeShare(); });
	revealNativeShare();

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', applyDiscountUiFromMemory);
	} else {
		applyDiscountUiFromMemory();
	}
	// Optimistic drawer open on add-to-cart click (before product-form ajax fires)
	document.addEventListener('click', function(e){
		var addBtn = e.target.closest && e.target.closest('button[name="add"], [data-add-to-cart]');
		if ( !addBtn ) return;
		if ( addBtn.disabled ) return;
		var form = addBtn.closest('form[action*="/cart/add"]');
		if ( !form ) return;
		var drawer = document.getElementById('site-cart');
		if ( drawer && !drawer.classList.contains('active') ) {
			drawer.classList.add('active');
			if ( document.body.classList ) document.body.classList.add('site-cart-active');
		}
	});

	// Side product add — animation slide-out + bouton "Ajout..." spinner
	document.addEventListener('click', function(e){
		var btn = e.target.closest && e.target.closest('#site-cart .amana-recs-list .actions button, #site-cart .amana-recs-list .actions .product__add-to-cart');
		if ( !btn ) return;
		var item = btn.closest('.cart-product-item');
		if ( !item || item.classList.contains('amana-rec-removing') ) return;
		btn.classList.add('amana-rec-pending');
		var originalText = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
		var span = btn.querySelector('span') || btn;
		span.textContent = 'Ajout';
		// Slide-out anim après 300ms (le temps que le fetch parte)
		setTimeout(function(){ item.classList.add('amana-rec-removing'); }, 300);
		// Reset bouton après 2s au cas où le drawer ne refresh pas
		setTimeout(function(){
			if ( btn ) { btn.classList.remove('amana-rec-pending'); span.textContent = originalText; }
		}, 2000);
	});

	// Mark new cart items après cart-updated for fade-in
	document.addEventListener('cart-updated', function(){
		setTimeout(function(){
			document.querySelectorAll('#AjaxCartForm [data-js-cart-item]').forEach(function(item, i){
				if ( item.dataset.amanaSeen ) return;
				item.dataset.amanaSeen = '1';
				// First time we see this item → fade-in
				item.classList.add('amana-newly-added');
				setTimeout(function(){ item.classList.remove('amana-newly-added'); }, 400);
			});
		}, 50);
	});

})();

